if (process.env.NODE_ENV === "production") {
  module.exports = require("./cjs/react.production.min.js")
} else {
  module.exports = require("./cjs/react.development.js")
}



//////////////////
// WEBPACK FOOTER
// ./~/@lingui/react/index.js
// module id = 19
// module chunks = 79611799117203 213534597649335